import * as React from 'react';
import styles from './SearchMain.module.scss';
import 'semantic-ui-css/semantic.min.css'
import { Redirect } from 'react-router-dom';
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faIgloo } from '@fortawesome/free-solid-svg-icons'
import { faSearch } from '@fortawesome/free-solid-svg-icons'
import { Container } from '@mui/material';
import { Icon } from 'semantic-ui-react';
import { ISearchHistory } from '../../intefaces';
import { DataService, IDataService } from '../../services';
import { FuzzySearch, Filter } from '..';

library.add(faIgloo)

interface ISearchMainProps { }
interface ISearchMainState {
    author: string;
    title: string;
    searchText: string;
    documentType: string;
    divisions: string[];
    redirect: boolean;
    isadvancedsearchclicked: boolean;
    exactSearch: string;
}


export class SearchMain extends React.Component<ISearchMainProps, ISearchMainState>{
    private _dataService: IDataService = new DataService();
    
    constructor(props: ISearchMainProps) {
        super(props);
        this.state = {
            author: '',
            title: '',
            searchText: '',
            documentType: '',
            divisions: [],
            redirect: false,
            isadvancedsearchclicked: false,
            exactSearch: 'true'
        }
    }

    componentDidMount() {
        this.setState({
            exactSearch: localStorage.getItem('fuzzySearch') || 'true'
        });
    }


    public render() {
        let searchQuery = `/search?q=${this.state.searchText}&fuzzy=${this.state.exactSearch}`;
        return (
            <>
                {this.state.redirect ? <Redirect to={searchQuery} /> : <div />}
                <Container className={styles.searchMainContainer}>
                    <div className={styles.search}>
                        <input
                            type='text'
                            placeholder='Type something to search'
                            name='search'
                            onChange={e => this.onTextChange(e)} value={this.state.searchText}
                            onKeyDown={(e: any) => this.onEnterButton(e)}
                        />
                        <button type="submit" onClick={this.onSearch.bind(this)} aria-label='Search'>
                            <FontAwesomeIcon icon={faSearch} />
                        </button>
                    </div>
                    <div className={styles.filter}>
                            <input 
                                type="text" 
                                placeholder='Filter by Author Name' 
                                name="namesearch"
                                onChange={e => this.onAuthorChange(e)} value={this.state.author}
                                onKeyDown={(e: any) => this.onEnterButton(e)}
                            />
                            <input 
                                type="text" 
                                placeholder='Filter by Title' 
                                name="titlesearch"
                                onChange={e => this.onTitleChange(e)} value={this.state.title}
                                onKeyDown={(e: any) => this.onEnterButton(e)}
                            />
                    </div>

                    <div className={styles.separator}></div>
                    <div>
                        <FuzzySearch className={styles.toggle} />
                    </div>
                    <label className={styles.advanceSearch} onClick={this.onAdvancedSearchClick.bind(this)}>
                        <p>Advanced search filters
                            {this.state.isadvancedsearchclicked ? <Icon name='angle up' size='big' /> : <Icon name='angle down' size='big' />}
                        </p>
                    </label>
                    {this.showAdvancedFilters()}

                </Container>
            </>
        )
    }


    private showAdvancedFilters() {
        return (
            <>
                {this.state.isadvancedsearchclicked ?
                    <Container>
                        <div className='dropdowns'>
                            <Filter onSearch={this.onSearch.bind(this)} />
                        </div>
                    </Container>
                    : <div />}
            </>
        );

    }

    private onAdvancedSearchClick() {
        this.setState({
            isadvancedsearchclicked: !this.state.isadvancedsearchclicked
        })
    }

    private onEnterButton = (event: any) => {
        if (event.keyCode === 13) {
            this.onSearch();
        }
    }

    private onTextChange(e: any) {
        this.setState({
            searchText: e.target.value || ''
        });
    }
    private onAuthorChange(e: any) {
        this.setState({
            author: e.target.value || ''
        });
    }
    private onTitleChange(e: any) {
        this.setState({
            title: e.target.value || ''
        });
    }

    private async onSearch() {
        const fuzzy = localStorage.getItem('fuzzySearch') || 'true';
        this.setState({
            exactSearch: fuzzy
        });
        localStorage.setItem("author", JSON.stringify(this.state.author ? [this.state.author] : []));
        localStorage.setItem("title", JSON.stringify(this.state.title? [this.state.title] : []));

        let _searchHistory: ISearchHistory = { searchTerm: this.state.searchText, searchUrl: `${window.location.origin}/search?q=${this.state.searchText}&fuzzy=${fuzzy}`};
        await this._dataService.CallUpdateSearchHistory(_searchHistory);
        this.setState({ redirect: true });
    }
}